/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import MarketStatus from './MarketStatus';

/**
 * The LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData model module.
 * @module model/LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData
 * @version 1.0
 */
class LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData {
    /**
     * Constructs a new <code>LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData</code>.
     * @alias module:model/LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData
     */
    constructor() { 
        
        LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData} obj Optional instance to populate.
     * @return {module:model/LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData} The populated <code>LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData();

            if (data.hasOwnProperty('listingNo')) {
                obj['listingNo'] = ApiClient.convertToType(data['listingNo'], 'Number');
            }
            if (data.hasOwnProperty('nftUid')) {
                obj['nftUid'] = ApiClient.convertToType(data['nftUid'], 'Number');
            }
            if (data.hasOwnProperty('nftKey')) {
                obj['nftKey'] = ApiClient.convertToType(data['nftKey'], 'String');
            }
            if (data.hasOwnProperty('boxType')) {
                obj['boxType'] = ApiClient.convertToType(data['boxType'], 'Number');
            }
            if (data.hasOwnProperty('boxRarity')) {
                obj['boxRarity'] = ApiClient.convertToType(data['boxRarity'], 'Number');
            }
            if (data.hasOwnProperty('boxBlessedFlag')) {
                obj['boxBlessedFlag'] = ApiClient.convertToType(data['boxBlessedFlag'], 'Boolean');
            }
            if (data.hasOwnProperty('boxImageUrl')) {
                obj['boxImageUrl'] = ApiClient.convertToType(data['boxImageUrl'], 'String');
            }
            if (data.hasOwnProperty('sigil')) {
                obj['sigil'] = ApiClient.convertToType(data['sigil'], 'String');
            }
            if (data.hasOwnProperty('lparentNftUid')) {
                obj['lparentNftUid'] = ApiClient.convertToType(data['lparentNftUid'], 'Number');
            }
            if (data.hasOwnProperty('rparentNftUid')) {
                obj['rparentNftUid'] = ApiClient.convertToType(data['rparentNftUid'], 'Number');
            }
            if (data.hasOwnProperty('metadataUrl')) {
                obj['metadataUrl'] = ApiClient.convertToType(data['metadataUrl'], 'String');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
            if (data.hasOwnProperty('lastImportedAt')) {
                obj['lastImportedAt'] = ApiClient.convertToType(data['lastImportedAt'], 'Date');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('pricePer')) {
                obj['pricePer'] = ApiClient.convertToType(data['pricePer'], 'Number');
            }
            if (data.hasOwnProperty('pricePerString')) {
                obj['pricePerString'] = ApiClient.convertToType(data['pricePerString'], 'String');
            }
            if (data.hasOwnProperty('priceHvh')) {
                obj['priceHvh'] = ApiClient.convertToType(data['priceHvh'], 'Number');
            }
            if (data.hasOwnProperty('priceHvhString')) {
                obj['priceHvhString'] = ApiClient.convertToType(data['priceHvhString'], 'String');
            }
            if (data.hasOwnProperty('priceUsdt')) {
                obj['priceUsdt'] = ApiClient.convertToType(data['priceUsdt'], 'Number');
            }
            if (data.hasOwnProperty('priceUsdtString')) {
                obj['priceUsdtString'] = ApiClient.convertToType(data['priceUsdtString'], 'String');
            }
            if (data.hasOwnProperty('priceArb')) {
                obj['priceArb'] = ApiClient.convertToType(data['priceArb'], 'Number');
            }
            if (data.hasOwnProperty('priceArbString')) {
                obj['priceArbString'] = ApiClient.convertToType(data['priceArbString'], 'String');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = MarketStatus.constructFromObject(data['status']);
            }
            if (data.hasOwnProperty('registedAt')) {
                obj['registedAt'] = ApiClient.convertToType(data['registedAt'], 'Date');
            }
            if (data.hasOwnProperty('sellerEmail')) {
                obj['sellerEmail'] = ApiClient.convertToType(data['sellerEmail'], 'String');
            }
            if (data.hasOwnProperty('sellerAccountNo')) {
                obj['sellerAccountNo'] = ApiClient.convertToType(data['sellerAccountNo'], 'Number');
            }
            if (data.hasOwnProperty('buyerEmail')) {
                obj['buyerEmail'] = ApiClient.convertToType(data['buyerEmail'], 'String');
            }
            if (data.hasOwnProperty('buyerAccountNo')) {
                obj['buyerAccountNo'] = ApiClient.convertToType(data['buyerAccountNo'], 'Number');
            }
            if (data.hasOwnProperty('transactedAt')) {
                obj['transactedAt'] = ApiClient.convertToType(data['transactedAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['nftKey'] && !(typeof data['nftKey'] === 'string' || data['nftKey'] instanceof String)) {
            throw new Error("Expected the field `nftKey` to be a primitive type in the JSON string but got " + data['nftKey']);
        }
        // ensure the json data is a string
        if (data['boxImageUrl'] && !(typeof data['boxImageUrl'] === 'string' || data['boxImageUrl'] instanceof String)) {
            throw new Error("Expected the field `boxImageUrl` to be a primitive type in the JSON string but got " + data['boxImageUrl']);
        }
        // ensure the json data is a string
        if (data['sigil'] && !(typeof data['sigil'] === 'string' || data['sigil'] instanceof String)) {
            throw new Error("Expected the field `sigil` to be a primitive type in the JSON string but got " + data['sigil']);
        }
        // ensure the json data is a string
        if (data['metadataUrl'] && !(typeof data['metadataUrl'] === 'string' || data['metadataUrl'] instanceof String)) {
            throw new Error("Expected the field `metadataUrl` to be a primitive type in the JSON string but got " + data['metadataUrl']);
        }
        // ensure the json data is a string
        if (data['pricePerString'] && !(typeof data['pricePerString'] === 'string' || data['pricePerString'] instanceof String)) {
            throw new Error("Expected the field `pricePerString` to be a primitive type in the JSON string but got " + data['pricePerString']);
        }
        // ensure the json data is a string
        if (data['priceHvhString'] && !(typeof data['priceHvhString'] === 'string' || data['priceHvhString'] instanceof String)) {
            throw new Error("Expected the field `priceHvhString` to be a primitive type in the JSON string but got " + data['priceHvhString']);
        }
        // ensure the json data is a string
        if (data['priceUsdtString'] && !(typeof data['priceUsdtString'] === 'string' || data['priceUsdtString'] instanceof String)) {
            throw new Error("Expected the field `priceUsdtString` to be a primitive type in the JSON string but got " + data['priceUsdtString']);
        }
        // ensure the json data is a string
        if (data['priceArbString'] && !(typeof data['priceArbString'] === 'string' || data['priceArbString'] instanceof String)) {
            throw new Error("Expected the field `priceArbString` to be a primitive type in the JSON string but got " + data['priceArbString']);
        }
        // ensure the json data is a string
        if (data['sellerEmail'] && !(typeof data['sellerEmail'] === 'string' || data['sellerEmail'] instanceof String)) {
            throw new Error("Expected the field `sellerEmail` to be a primitive type in the JSON string but got " + data['sellerEmail']);
        }
        // ensure the json data is a string
        if (data['buyerEmail'] && !(typeof data['buyerEmail'] === 'string' || data['buyerEmail'] instanceof String)) {
            throw new Error("Expected the field `buyerEmail` to be a primitive type in the JSON string but got " + data['buyerEmail']);
        }

        return true;
    }


}



/**
 * @member {Number} listingNo
 */
LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData.prototype['listingNo'] = undefined;

/**
 * @member {Number} nftUid
 */
LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData.prototype['nftUid'] = undefined;

/**
 * @member {String} nftKey
 */
LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData.prototype['nftKey'] = undefined;

/**
 * @member {Number} boxType
 */
LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData.prototype['boxType'] = undefined;

/**
 * @member {Number} boxRarity
 */
LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData.prototype['boxRarity'] = undefined;

/**
 * @member {Boolean} boxBlessedFlag
 */
LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData.prototype['boxBlessedFlag'] = undefined;

/**
 * @member {String} boxImageUrl
 */
LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData.prototype['boxImageUrl'] = undefined;

/**
 * @member {String} sigil
 */
LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData.prototype['sigil'] = undefined;

/**
 * @member {Number} lparentNftUid
 */
LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData.prototype['lparentNftUid'] = undefined;

/**
 * @member {Number} rparentNftUid
 */
LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData.prototype['rparentNftUid'] = undefined;

/**
 * @member {String} metadataUrl
 */
LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData.prototype['metadataUrl'] = undefined;

/**
 * @member {Date} createdAt
 */
LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData.prototype['createdAt'] = undefined;

/**
 * @member {Date} lastImportedAt
 */
LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData.prototype['lastImportedAt'] = undefined;

/**
 * @member {Number} accountNo
 */
LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData.prototype['accountNo'] = undefined;

/**
 * @member {Number} pricePer
 */
LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData.prototype['pricePer'] = undefined;

/**
 * @member {String} pricePerString
 */
LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData.prototype['pricePerString'] = undefined;

/**
 * @member {Number} priceHvh
 */
LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData.prototype['priceHvh'] = undefined;

/**
 * @member {String} priceHvhString
 */
LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData.prototype['priceHvhString'] = undefined;

/**
 * @member {Number} priceUsdt
 */
LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData.prototype['priceUsdt'] = undefined;

/**
 * @member {String} priceUsdtString
 */
LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData.prototype['priceUsdtString'] = undefined;

/**
 * @member {Number} priceArb
 */
LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData.prototype['priceArb'] = undefined;

/**
 * @member {String} priceArbString
 */
LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData.prototype['priceArbString'] = undefined;

/**
 * @member {module:model/MarketStatus} status
 */
LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData.prototype['status'] = undefined;

/**
 * @member {Date} registedAt
 */
LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData.prototype['registedAt'] = undefined;

/**
 * @member {String} sellerEmail
 */
LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData.prototype['sellerEmail'] = undefined;

/**
 * @member {Number} sellerAccountNo
 */
LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData.prototype['sellerAccountNo'] = undefined;

/**
 * @member {String} buyerEmail
 */
LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData.prototype['buyerEmail'] = undefined;

/**
 * @member {Number} buyerAccountNo
 */
LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData.prototype['buyerAccountNo'] = undefined;

/**
 * @member {Date} transactedAt
 */
LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData.prototype['transactedAt'] = undefined;






export default LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData;

